import { gql } from 'graphql-request';
import { useMutation } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useFinishOnboardingInfo = () => {
  const { client } = graphqlConfig();
  const Mutation = useMutation(async (courseId?: number) => client.request(
    gql`
    mutation UserFinishOnboardingInfo($courseId: Float!) {
        userFinishOnboardingInfo(courseId: $courseId) {
            message
        }
    }
    `,
    {
      courseId,
    }
  ));
  return Mutation;
};
